import React from 'react';
import TabComponent from '@components/TabComponent';
import Amenities from './Amenities';
import Sustainability from './Sustainability';
import Location from './Location';
import cn from './style.module.scss';
export default function SpecificationTab(props: any) {
  const { t } = props;
  const tabs = [
    {
      title: t['yasTabOneLabel'],
      content: (
        <>
          <Amenities
            t={t}
            themeImg={props.tabImages[0].themeImg}
            bgImg={props.tabImages[0].bgImg}
          />
        </>
      ),
    },
    {
      title: t['yasTabTwoLabel'],
      content: (
        <>
          <Sustainability
            t={t}
            themeImg={props.tabImages[1].themeImg}
            bgImg={props.tabImages[1].bgImg}
          />
        </>
      ),
    },
    {
      title: t['yasTabThreeLabel'],
      content: (
        <>
          <Location
            t={t}
            themeImg={props.tabImages[2].themeImg}
            bgImg={props.tabImages[2].bgImg}
          />
        </>
      ),
    },
  ];
  return (
    <>
      <TabComponent
        tabs={tabs}
        tabClass={cn.launchTabNavigation}
        className={cn.launchGRDTabs}
        activeClassName={cn.activeLink}
      />
    </>
  );
}
